var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebookDefault = function SvgFacebookDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.484 0H3.516A3.52 3.52 0 0 0 0 3.516v16.968A3.52 3.52 0 0 0 3.516 24h7.078v-8.484H7.78v-4.22h2.813V8.439a4.223 4.223 0 0 1 4.219-4.22h4.265v4.22h-4.265v2.859h4.265l-.703 4.219h-3.563V24h5.672A3.52 3.52 0 0 0 24 20.484V3.516A3.52 3.52 0 0 0 20.484 0z",
    fill: "#FFF"
  })));
};

export default SvgFacebookDefault;